export const YAK_CHAT_LOADING = 'YAK_CHAT_LOADING';
export const YAK_CHAT_SUCCESS = 'YAK_CHAT_SUCCESS';
export const YAK_CHAT_ERROR = 'YAK_CHAT_ERROR';
export const YAK_CHAT_ADD_USER = 'YAK_CHAT_ADD_USER';
export const YAK_CHAT_ADD_AI = 'YAK_CHAT_ADD_AI';
export const YAK_CHAT_RESET = 'YAK_CHAT_RESET';


// WEBPACK FOOTER //
// ./src/stores/tack_ai_chat/action_types.js